export default __webpack_public_path__ + "static/gs-8-deploymodel-205deba188b2b9b4e9aa879273bab1f4.jpg";